import styled from 'styled-components'

export const PageContainer = styled.div`
  padding: 2rem;
  min-height: 100vh;
`
